import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { Navigate } from 'react-router-dom';
import { Loading } from '@ibk/shared-ui';
import { useDigitalAccountingAccess } from './useDigitalAccountingAccess';
export function DigitalAccountingGuard({ children }) {
    const { isResolved, hasPermission } = useDigitalAccountingAccess();
    if (!isResolved) {
        return _jsx(Loading, { fullScreen: true });
    }
    if (!hasPermission) {
        return _jsx(Navigate, { to: '/home', replace: true });
    }
    return _jsx(React.Fragment, { children: children });
}
